import { render, staticRenderFns } from "./blogArticle.vue?vue&type=template&id=99db7eee&scoped=true"
import script from "./blogArticle.vue?vue&type=script&lang=js"
export * from "./blogArticle.vue?vue&type=script&lang=js"
import style0 from "./blogArticle.vue?vue&type=style&index=0&id=99db7eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db7eee",
  null
  
)

export default component.exports